import { isAfter, isBefore, isWithinInterval } from 'date-fns';

export function isInRange(date: Date, minDate?: Date, maxDate?: Date): boolean {
  if (minDate && maxDate && isBefore(minDate, maxDate))
    return isWithinInterval(date, { start: minDate, end: maxDate });
  if (minDate) return isAfter(date, minDate);
  if (maxDate) return isBefore(date, maxDate);
  return true;
}
